/**
 * Montos de envío (USD) que el tenant escribe en el formulario del bot. Vacío significa "sin configurar":
 * el bot no cita ningún costo de envío y avisa que el equipo lo confirma.
 */

const AMOUNT_PATTERN = /^\d+(?:[.,]\d{1,2})?$/

export function isValidShippingAmountInput(raw: string): boolean {
  const value = raw.trim()
  return value === '' || AMOUNT_PATTERN.test(value)
}

/** `''` -> `null`; `'3,5'` -> `3.5`. Solo se llama con entradas ya validadas. */
export function parseShippingAmount(raw: string): number | null {
  const value = raw.trim()
  if (!AMOUNT_PATTERN.test(value)) return null
  return Number(value.replace(',', '.'))
}

export function formatShippingAmount(value: number | null | undefined): string {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? String(value) : ''
}

export const SHIPPING_AMOUNT_ERROR = 'Ingresa un monto válido en USD (ej. 3 o 3.50)'
